import React, { useEffect } from "react";
import { Row, Form } from "react-bootstrap";

import { useGlobalState } from '../../components/globalStateProvider.js';
import { machineListSelectedAPI } from '../../api/api_definitions.js';

const MachineFamilyListStats = ({ index, block }) => {

    const { updateStatsBlock } = useGlobalState();

    // Quando cambia machineFamily → resetta customerName, listSN ecc. (gestito già nel provider)
    const handleChange = (e) => {
        const value = e.target.value;
        if (value !== "0") {
            updateStatsBlock(index, "machineFamily", value);
        }
    };

    // Carica la lista dei clienti dopo aver selezionato machineFamily
    useEffect(() => {
        let isMounted = true;

        if (!block.machineFamily || block.machineFamily === 0) return;

        machineListSelectedAPI(block.machineFamily)
            .then((dataAPI) => {
                if (isMounted && dataAPI !== null) {
                    updateStatsBlock(index, "listCustomerMachines", dataAPI.ListMachines);
                }
            })
            .catch((error) => {
                console.log(error);
            });

        return () => { isMounted = false };
    }, [block.machineFamily]);

    
    return (
            <Form.Select className="w-100 h-100"
                aria-label="select machine family"
                value={block.machineFamily}
                onChange={handleChange}
            >
                <option value="0" disabled>Seleziona la famiglia macchina</option>
                <option value="1">Laser Genius +</option>
                <option value="4">Platino Linear</option>
            </Form.Select>
    );
};

export default MachineFamilyListStats;
